<form [formGroup]="accessForm" (ngSubmit)="onSubmit()">
  <div class="row mb-3">
    <div class="col-md-12">
      <div class="form-group">
        <label for="emailAddress">Email Address</label>
        <input type="email" class="form-control" id="emailAddress" formControlName="email" placeholder="Eg. abc@gmail.com" />
        <div *ngIf="f.email.invalid && (f.email.dirty || f.email.touched)" class="text-danger">
          <small *ngIf="f.email.errors?.required">Email is required</small>
          <small *ngIf="f.email.errors?.email">Invalid email address</small>
        </div>
      </div>
    </div>
  </div>
  <div class="row mb-3">
    <div class="col-md-12">
      <div class="form-group">
        <label for="subscriptionType">Subscription Type</label>
        <select class="form-select cursor-pointer" id="subscriptionType" formControlName="subscription_type">
          <option value="">Select Subscription Type</option>
          <option *ngFor="let type of subscriptionTypes" [value]="type">{{ type }}</option>
        </select>
        <div *ngIf="f.subscription_type.invalid && (f.subscription_type.dirty || f.subscription_type.touched)" class="text-danger">
          <small *ngIf="f.subscription_type.errors?.required">Subscription type is required</small>
        </div>
      </div>
    </div>
  </div>
  <div class="row mb-3">
    <div class="col-md-12">
      <div class="form-group">
        <label for="durationMonths">Duration (Months)</label>
        <select class="form-select cursor-pointer" id="durationMonths" formControlName="duration_months">
          <option value="">Select Duration</option>
          <option *ngFor="let months of durationMonths" [value]="months">{{ months }} {{ months === 1 ? 'Month' : 'Months' }}</option>
        </select>
        <div *ngIf="f.duration_months.invalid && (f.duration_months.dirty || f.duration_months.touched)" class="text-danger">
          <small *ngIf="f.duration_months.errors?.required">Duration is required</small>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-end mt-3">
    <button type="button" class="btn custom-button me-2" (click)="onCancel()" data-bs-dismiss="modal">Cancel</button>
    <button type="submit" class="btn custom-button">Submit</button>
  </div>
</form>

